<template>
  <div class="main-content queryInvoice">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="showSimple"
      :expand-adv="true"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :is-simple-query.sync="isSimpleQuery"
      :custom-sim-query-placeholder="customSimQueryPlaceholder"
      :config-module="configModule"
      :col-settings="colSettings"
      @query="queryBtnClickHandler"
      @advToggle="scrollCallback"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :min-height="hasVoucher===0?'350px':'200px'"
      />
    </div>
    <div id="footer-wrapper-tab-actualamount" class="pagination-wrapper">
      <div v-if="showChargeCurrencyTotalGroup" :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 5px">
        <span v-show="dataShow && totalAmountToCurrency.selectionCountLabel" v-text="totalAmountToCurrency.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc"
          ar-field="ar"
          currency-field="currency"
          data-field="amount"
          :amount-to-currency="localCurrency"
          rate-field="rate"
          type="revenueAbs"
          :amount-to-currency-label="$t('Message.Convert')"
          :data-provider="totalAmountToCurrency.dataProvider"
          :arap-group="arapGroup"
        />
      </div>
      <cargo-pagination
        :config-module="gridConfigModule"
        :total="pageConditions.total"
        :page.sync="pageConditions.pageNum"
        :limit.sync="pageConditions.pageSize"
        @pagination="query"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import { formatNumberToThousands } from '@/utils'
import StrUtils from '@/utils/StrUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import { getLoading } from '@/utils/utilBaseElement'
import * as writeoffApi from '@/api/act/writeoff'
import { cache, cacheName } from '@/utils/cacheManager'
import { getBankAccountList } from '@/api/bankAccount'
import { ApiCacheManage, Once } from '@/utils/commonUtil'
import { getGridSelected } from '@/utils/agGrid'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import moment from 'moment'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { OPERATOR_EQUAL, OPERATOR_IS_NULL, OPERATOR_UNEQUAL } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'

export default {
  name: 'QueryActualAmount',
  components: { searchItem, ChargeCurrencyTotalGroup },
  props: {
    identify: { type: String, required: true, default: 'queryActualAmount' }, // ID
    viewSource: { type: String, required: true, default: 'VoucherList' }, // 引用页面
    customSimQueryPlaceholder: { type: String, default: '' },
    configModule: { type: String, default: '510' },
    gridConfigModule: { type: String, default: '191001' },
    // 查询参数
    ar: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外
    isBankSlip: { type: Number, default: -1 }, // 是否水单
    isPrepay: { type: Number, default: -1 }, // 是否预付
    isRealSendReceive: { type: Boolean, default: false }, // 是否实收实付模块
    arapGroup: { type: Boolean, default: false }, // 是否显示应收应付
    verfDate: { type: Object, default: null }, // 销账日期  [开始日期,结束日期]
    preQuery: { type: Function, default: null }, // 查询前置处理
    showChargeCurrencyTotalGroup: { type: Boolean, default: true }, // 显示数据统计
    cargoGridStateBtn: { type: Boolean, default: false }, // 显示按钮：保存列状态、显示列状态
    showSimple: { type: Boolean, default: true },
    gridHeight: { type: String, default: '' },
    dialogHeight: { type: String, default: '' },
    isDialog: { type: Boolean, default: false }, // 对话框中引用组件时不撑开aggrid
    accountId: { type: Number, default: 0 }, // 结算单位
    rowSelectionType: { type: String, default: 'multiple' }, // 是否多选
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showControlledCharge: { type: Boolean, default: true }, // 显示受控费用
    showVoucherDate: { type: Boolean, default: false }, // 是否显示生成凭证日期
    showInvoiceDetail: { type: Boolean, default: false }, // 是否显示发票明细
    showBillPaymentDetail: { type: Boolean, default: false }, // 是否显示付款申请号
    remainCondition: { type: Boolean, default: false }, // 余额条件
    isExt: { type: Boolean, default: false },
    accountSetKey: { type: String, default: '' }, // 账套uuid
    hasVoucher: { type: Number, default: -1 }, // 是否已经生成过凭证:1=是,0=否
    preBankSlipStates: { type: Array, default: () => [] }, // 预收款状态
    hasPreReceiptPayment: { type: Boolean, default: false }, // 是否维护预收付凭证
    hasChargePrePayment: { type: Boolean, default: false }, // 是否维护预收付-水单
    bizDataType: { type: Number, default: 0 }, // 凭证类型
    colSettings: { type: Object },
    accountSetBranchId: { type: Number, default: 0 } // 账套branchId
  },
  data() {
    return {
      receiptInvoiceTitles: [],
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true,
      // 当前选中行
      clickRow: null,
      // 查询参数
      isSimpleQuery: false, // 是否简单查询
      exceptKeys: [], // 在查询中想要例外的对象列表
      enableCalcSourceRateDiff: true, // 是否计算原币汇差
      // 银行账户列表（列表渲染使用）
      bankAccounts: null,
      cashTransferStates: [], // 水单状态列表
      // 保存上次查询的查询条件
      conditionsAndRequires: null,
      // loading遮罩层
      loading: null,
      rowData: [],
      gridParams: {},
      gridOptions: {},
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('WriteOff.writeOffSerialNumber'),
          field: 'actualAmountNo',
          colId: 'actualAmountNo',
          width: 140
        }, {
          headerName: this.$t('WriteOff.settleAccountsTo'),
          field: 'accountId',
          colId: 'accountId',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.theOppositeSideCompany'),
          field: 'paymentCompany',
          colId: 'paymentCompany',
          width: 140
        }, {
          headerName: this.$t('WriteOff.ourSideBank'),
          field: 'ourBank',
          colId: 'ourBank',
          width: 100,
          cellRenderer: (params) => {
            return this.queryOurBankLabelFunc(params.data)
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.billPaymentNo'),
          field: 'billPaymentNo',
          colId: 'billPaymentNo',
          width: 100
        }, {
          headerName: this.$t('WriteOff.proofNo'),
          field: 'voucherNo',
          colId: 'voucherNo',
          width: 100,
          cellRenderer: (params) => {
            return params.value || params.data.documentNo || ''
          }
        }, {
          headerName: this.$t('WriteOff.bankReceiptNo'),
          field: 'bankWaterNo',
          colId: 'bankWaterNo',
          width: 100
        }, {
          headerName: this.$t('WriteOff.writeOffPerson'),
          field: 'verificationBy',
          colId: 'verificationBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.writeOffDate'),
          field: 'verificationDate',
          colId: 'verificationDate',
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.revenueAndExpenditureDate'),
          field: 'payReceiveDate',
          colId: 'payReceiveDate',
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.proofDate'),
          field: 'voucherExportDate',
          colId: 'voucherExportDate',
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          },
          hide: this.showVoucherDate
        },
        { headerName: this.$t('CargoMsg.Cargo_VoucherLetter'), field: 'prefix', width: 80 },
        {
          headerName: this.$t('WriteOff.paymentType'),
          field: 'ar',
          colId: 'ar',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        }, {
          headerName: this.$t('WriteOff.bankReceiptStatus'),
          field: 'cashTransferState',
          colId: 'cashTransferState',
          width: 100,
          cellRenderer: (params) => {
            return this.cashTransferStateLabelFun(params.data, 'cashTransferState')
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.revenueAndExpenditureMethod'),
          field: 'type',
          colId: 'type',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.amountReceiveTypeLabelFun(params.value)
          }
        }, {
          headerName: this.$t('WriteOff.prepaidOrNot'),
          field: 'isPrepay',
          colId: 'isPrepay',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('WriteOff.currency'),
          field: 'currency',
          colId: 'currency',
          width: 100
        }, {
          headerName: this.$t('WriteOff.amount'),
          field: 'amount',
          colId: 'amount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(this.amountNumberColumnLabelFunc(params.data, 'amount'))
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.theAmountOfWrittenOff'),
          field: 'verfiedAmount',
          colId: 'verfiedAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(this.amountNumberColumnLabelFunc(params.data, 'verfiedAmount'))
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.balance'),
          field: 'remainAmount',
          colId: 'remainAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(this.remainAmountLabelFunc(params.data))
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.actualReceiptAmount'),
          field: 'arAmount',
          colId: 'arAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumberReturnZero(params.value, 2))
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.actualPaymentAmount'),
          field: 'apAmount',
          colId: 'apAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumberReturnZero(params.value, 2))
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.financialCharges'),
          field: 'financialCost',
          colId: 'financialCost',
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          }
        }, {
          headerName: this.$t('WriteOff.exchangeGainsAndLosses'),
          field: 'diffChange',
          colId: 'diffChange',
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          }
        }, {
          headerName: this.$t('WriteOff.oddment'),
          field: 'clearOdd',
          colId: 'clearOdd',
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          }
        }, {
          // 原币汇差
          headerName: this.$t('WriteOff.originalCurrencyExchangeDifference'),
          field: 'sourceRateDiff',
          colId: 'sourceRateDiff',
          width: 100,
          cellRenderer: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          },
          hide: this.enableCalcSourceRateDiff
        }, {
          headerName: this.$t('WriteOff.creator'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.recheck'),
          field: 'approvedState',
          colId: 'approvedState',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.actAmountApproveLabelFun(params.value)
          }
        }, {
          headerName: this.$t('WriteOff.RecheckDate'),
          field: 'dateApproved',
          colId: 'dateApproved',
          width: 100,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.invalid'),
          field: 'state',
          colId: 'state',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.actAmountStateLabelFun(params.value)
          }
        }, {
          headerName: this.$t('WriteOff.invoicingInformation'),
          field: 'invoiceDetail',
          colId: 'invoiceDetail',
          width: 100,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('WriteOff.remark'),
          field: 'remark',
          colId: 'remark',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_WriteOffHeader'),
          field: 'actualAmountTitle',
          colId: 'actualAmountTitle',
          enableRowGroup: true,
          hide: true,
          width: 120
        }, {
          headerName: this.$t('WriteOff.dayOfCreditTerm'),
          field: 'creditTerm',
          colId: 'creditTerm',
          width: 100
        }, {
          // 对方凭证号
          headerName: this.$t('WriteOff.targetVoucherNo'),
          field: 'targetVoucherNo2Charge',
          colId: 'targetVoucherNo2Charge',
          width: 100,
          hide: true
        }, {
          // 凭证日期
          headerName: this.$t('WriteOff.voucherDate'),
          field: 'voucherDate2Charge',
          colId: 'voucherDate2Charge',
          width: 100,
          hide: true,
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }
      ],
      once: new Once(this),
      // 分页
      pageConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      // 分页组件内统计数据
      totalAmountToCurrency: {
        dataProvider: [],
        selectionCountLabel: ''
      },
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      shouldFixed: false,
      querying: false // 查询中
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  async created() {
    // 设置勾选行数据时执行一次数据统计
    const self = this
    this.gridOptions = {
      rowSelection: self.rowSelectionType,
      suppressCellSelection: true,
      defaultColDef: {
        resizable: true,
        filter: true
      },
      pagination: false,
      onSelectionChanged: this.filterChange,
      onRowDoubleClicked: this.rowDoubleClickedHandler,
      onRowClicked: this.rowClicked,
      onRowSelected: this.onRowChecked
    }
    // 配置加载
    await cache.load(cacheName.CONFIG)
    // 是否计算原币汇差
    this.enableCalcSourceRateDiff = parseInt(cache.config.get('enableCalcSourceRateDiff')) === 1
    // 加载银行账户列表（列表渲染使用）
    this.bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
      return res.data
    })
    this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  mounted() {

  },
  methods: {
    // 查询 按钮事件
    queryBtnClickHandler(conditionsMap) {
      if (this.preQuery && !this.preQuery()) return
      let conditions = conditionsMap.conditions
      // 查询销账流水号
      if (conditionsMap.simpleTriggerMode && conditions) {
        // 简单查询时conditions是字符串
        const value = conditions
        conditions = []
        conditions.push(new AdvancedSearchOption('FIELD_TEXT', 'actualAmount.ACTUALAMOUNTNO', value, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
      }
      const requires = []
      // CARGO-9716，销账日期：第一次点击查询没有生效，第二点击查询才生效
      // const verificationDateSearchOption = this.verfDate
      // if (verificationDateSearchOption != null) {
      //   conditions.push(verificationDateSearchOption.formatObj2Json())
      // }
      // if (this.viewSource !== 'VoucherList') {
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (!this.inputDateStart && this.inputDateEnd) {
        inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, this.viewSource === 'VoucherList' ? 'actualAmount.PAY_RECEIVE_DATE' : 'actualAmount.VERIFICATIONDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        conditions.push(condition.formatObj2Json())
      }
      // }
      if (this.ar !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.AR', this.ar === 1).formatObj2Json())
      }
      if (this.oversea !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'charge.OVERSEA', this.oversea === 1).formatObj2Json())
      }

      if (this.isPrepay !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', this.isPrepay === 1).formatObj2Json())
      }

      if (this.isBankSlip !== -1) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.BANK_SLIP', this.isBankSlip === 1).formatObj2Json())
      }

      // 结算单位
      if (this.accountId > 0) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.ACCOUNTID', this.accountId, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }

      if (this.exceptKeys && this.exceptKeys.length > 0) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.UUID', this.exceptKeys, AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
      }

      if (this.preBankSlipStates !== null && this.preBankSlipStates.length > 0) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PRE_BANK_SLIP_STATE', this.preBankSlipStates, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.PRE_PAYMENT', true).formatObj2Json())
        requires.push('checkVoucherPrePayment')
      } else {
        // 是否生成凭证
        if (this.hasVoucher !== -1 && !StrUtils.isEmpty(this.accountSetKey)) {
          conditions.push(new AdvancedSearchOption(null, SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, { 'accountSetKey': this.accountSetKey }, this.hasVoucher === 1 ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
        }
      }

      // CARGO-8364，预收付凭证
      if (FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code === this.bizDataType) {
        if (this.hasChargePrePayment) {
          conditions.push(new AdvancedSearchOption(null, 'actualAmount._PRE_RECEIPT_PAYMENT_VOUCHERED_BANK_SLIP_', true).formatObj2Json())
        } else {
          conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', 1).formatObj2Json())
        }
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.IMPORT_DATA', 1).formatObj2Json())
        requires.push('checkVoucherPrePayment')
        if (AdvancedSearchOption.hasField(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)) {
          // AdvancedSearchOption.removeOption(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)
        }
      } else if (FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code === this.bizDataType) {
        if (this.hasChargePrePayment) {
          conditions.push(new AdvancedSearchOption(null, 'actualAmount._PRE_RECEIPT_PAYMENT_VOUCHERED_BANK_SLIP_', true).formatObj2Json())
        } else {
          conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', 1).formatObj2Json())
        }
      } else {
        if (this.hasPreReceiptPayment) {
          // CARGO-47839，开启预收付核销数据类型后，水单认领完成，实收付核销数据类型查不到水单认领完成的数据
          if (this.hasChargePrePayment) {
            conditions.push(new AdvancedSearchOption(null, 'actualAmount._RECEIPT_PAYMENT_VOUCHERED_BANK_SLIP_', true).formatObj2Json())
          } else {
            conditions.push(new AdvancedSearchOption(null, 'actualAmount.PREPAY', 1, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json())
          }
        }
      }

      if (AdvancedSearchOption.hasField(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)) {
        const special = AdvancedSearchOption.removeOption(SpecialFieldConstants.ACTUAL_AMOUNT_VOUCHERED, conditions)
        if (!special) return
        let operator = special.operator
        if (operator === AdvancedSearchConsts.OPERATOR_IS_NULL.code) {
          operator = AdvancedSearchConsts.OPERATOR_NOT_IN.code
        } else if (operator === AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code) {
          operator = AdvancedSearchConsts.OPERATOR_IN.code
        }
        // CARGO-33921，预付账款冲回
        if (FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code === this.bizDataType) {
          if (!StrUtils.isEmpty(this.accountSetKey)) {
            conditions.push(new AdvancedSearchOption(null, 'clearHistory._checkReceiptPaymentOffset_', { 'accountSetKey': this.accountSetKey }).formatObj2Json())
          }
          special.fieldName = 'clearHistory._receiptPaymentOffsetVouchered_'
        }
        conditions.push(new AdvancedSearchOption(null, special.fieldName, special.value, operator).formatObj2Json())
      }

      // 我方银行：值转换
      if (AdvancedSearchOption.hasField('actualAmount.OURBANK', conditions)) {
        // const option = AdvancedSearchOption.removeOption('actualAmount.OURBANK', conditions)
        // const bankAccount = this.bankAccounts.find(p => (p.bankChineseName + '' + p.currency) === String(option.value))
        // if (bankAccount) {
        //   option.value = bankAccount.bankChineseName
        // }
        // conditions.push(option)
      }

      // 认领状态：全部
      if (AdvancedSearchOption.hasField('actualAmount.BANK_SLIP_STATE', conditions)) {
        const option = AdvancedSearchOption.getOption('actualAmount.BANK_SLIP_STATE', conditions)
        const valueArray = option.value
        let seachAll = false
        valueArray.forEach(function(value) {
          if (value === -1) seachAll = true
        })
        if (seachAll) AdvancedSearchOption.removeOption('actualAmount.BANK_SLIP_STATE', conditions)
      }

      if (this.remainCondition) {
        conditions.push(new AdvancedSearchOption(null, 'actualAmount.REMAINAMOUNT', 0, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json())
      }

      // if (!this.showControlledCharge) {
      //   this.getControlledConditions(conditions)
      // }

      if (this.showVoucherDate) {
        requires.push('voucherDate')
      }
      if (this.showInvoiceDetail) {
        requires.push('invoice')
      }
      if (this.showBillPaymentDetail) {
        requires.push('billPayment')
      }
      // 我方银行：多选改写为 ourBankAccount(账号) 列的 IN/NOT IN
      // ourBank 列存银行名（中/英按语言混存），多值匹配用 ourBankAccount 账号列更稳；不走 writeQuery 单值路径
      if (AdvancedSearchOption.hasField('actualAmount.OURBANK', conditions)) {
        const ourBankOption = AdvancedSearchOption.getOption('actualAmount.OURBANK', conditions)
        const selectedCodes = Array.isArray(ourBankOption.value) ? ourBankOption.value : (ourBankOption.value !== '' && ourBankOption.value != null ? [ourBankOption.value] : [])
        AdvancedSearchOption.removeOption('actualAmount.OURBANK', conditions)
        if (selectedCodes.length > 0) {
          // 选中 code(accountNo+currency) → accountNo（去重）
          const accountNos = []
          selectedCodes.forEach(code => {
            const bankAccount = this.bankAccounts.find(p => (p.accountNo + '' + p.currency) === String(code))
            if (bankAccount && !accountNos.includes(bankAccount.accountNo)) accountNos.push(bankAccount.accountNo)
          })
          if (accountNos.length > 0) {
            // 运算符规范化：后端对多值数组统一按 IN，故 != 需映射为 NOT IN
            const isExclude = ourBankOption.operator === AdvancedSearchConsts.OPERATOR_UNEQUAL.code || ourBankOption.operator === AdvancedSearchConsts.OPERATOR_NOT_IN.code
            conditions.push(new AdvancedSearchOption(null, 'actualAmount.ourBankAccount', accountNos, isExclude ? AdvancedSearchConsts.OPERATOR_NOT_IN.code : AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
          }
        }
      }
      this.preQueryActualAmount(conditions)
      // CARGO-1776，发票查询，付款申请，销账查询界面增加对方凭证号，凭证日期：默认隐藏
      requires.push('targetVoucherNo')
      // CARGO-981，汇兑损益汇率
      if (this.enableCalcSourceRateDiff) {
        requires.push('calcSourceRateDiff')
      }
      // 【财务管理-生成凭证-实际收付、国内收款、国内付款、国外收款、国外付款、预收付、预收付凭证、预收付核销】页签（通过核销历史过滤分公司）
      // CARGO-33162 环海：水单认领模块，预收款认领后，生成凭证查不到
      if (this.viewSource === 'VoucherList' && this.identify != 'chargePrePaymentSearchItem') {
        requires.push('filterBranchIdByClearHistory')
      }
      // 实际收付，则传requestSource
      // CARGO-32785 UBI:已生成凭证查询，显示列增加凭证字号
      if (this.viewSource === 'VoucherList' && this.bizDataType === Number(FinanceInterfaceConstants.RECEIPT_PAYMENT.code)) {
        requires.push('voucherPage')
      }
      // 保存查询条件
      this.conditionsAndRequires = { conditions, requires }
      this.query()
    },
    async query() {
      this.clickRowClear()
      if (!this.conditionsAndRequires) return
      const conditions = this.conditionsAndRequires.conditions
      const requires = this.conditionsAndRequires.requires
      const params = {
        branchId: this.accountSetBranchId ? this.accountSetBranchId : this.$store.getters.currentOfficeId,
        conditions,
        requires,
        pageSize: this.pageConditions.pageSize,
        pageNum: this.pageConditions.pageNum
      }
      const self = this
      this.querying = true
      self.loading = getLoading()

      if (this.isRealSendReceive) {
        await writeoffApi.queryActualAmountOldPageable(params).then(res => {
          self.resultHandler(res, self)
        }).catch(err => {
          self.faultHandler(err)
        })
        // ActualAmount.queryActualAmountOldPageable(conditions, requires, pageBar.pageSize, pageBar.currentPage, resultHandler, faultHandler)
      } else {
        await writeoffApi.queryActualAmountPageable(params).then(res => {
          self.resultHandler(res, self)
        }).catch(err => {
          self.faultHandler(err)
        })
        // ActualAmount.queryActualAmountPageable(conditions, requires, pageBar.pageSize, pageBar.currentPage, resultHandler, faultHandler)
      }
      self.loading.close()
      this.querying = false
      // 查询完成后更新右下角统计数据
      this.refreshSelectedCount()
      // 重置
      this.$emit('clickedCallBack', null)
      this.gridOptions.api.clearFocusedCell()
    },
    // 查询前置操作
    preQueryActualAmount(conditions) {
      if (cache.config.get('ext') === '1') {
        for (const option of conditions) {
          if (option.fieldName === 'actualAmount.ACTUALAMOUNTNO' && option.value &&
              option.operator === AdvancedSearchConsts.OPERATOR_EQUAL.code &&
              option.value instanceof String &&
              String(option.value).indexOf(',') > 0) {
            option.value = String(option.value).split(',')
            break
          }
        }
      }
    },
    // 获取charge控制条件
    getControlledConditions(conditions) {
      // 是否有应付受控费用权限
      const isControlled = this.$checkPermission(['button_Charge_controlled'])
      // 是否有应收受控费用权限
      const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
      let value = 0
      if (!isControlled && !isCostControlled) {
        value = 1
      } else if (!isControlled) {
        value = 2
      } else if (!isCostControlled) {
        value = 3
      }
      if (value !== 0) {
        conditions.push(new AdvancedSearchOption(null, 'cIsControlled', value).formatObj2Json())
      }
    },
    resultHandler(res, self) {
      const data = res.data
      self.pageConditions.total = Number(data.total)
      self.pageConditions.pageNum = Number(data.pageNum)
      self.rowData = data.list
      self.$emit('queryResultCallBack', data.list)
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    // 行双击事件
    rowDoubleClickedHandler(event) {
      this.clickRow = event.data
      this.$emit('doubleClickedCallBack', event.data)
    },
    // 行单击事件
    rowClicked(event) {
      this.clickRow = event.data
      console.log('querying', this.querying)
      if (!this.querying) this.$emit('clickedCallBack', event.data)
    },
    // 行首多选框勾选事件
    onRowChecked(event) {
      if (event.node.isSelected()) {
        this.rowClicked(event)
      }
    },
    // 置空clickRow
    clickRowClear() {
      this.clickRow = null
    },
    // 列表checkBox选中变更事件
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg == 0) {
        const selectStr = this.$i18n.locale === 'zh' ? '选中' : 'selected'
        this.totalAmountToCurrency.selectionCountLabel = selectStr + ' ' + selections.length + '：'
        this.totalAmountToCurrency.dataProvider = selections
      } else if (arg == 1) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectionCountLabel = ''
      } else {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.totalAmountToCurrency.selectionCountLabel = ''
      }
    },
    // 修改指定行数据并重新渲染列表
    refreshRow(data) {
      const index = this.rowData.findIndex(row => { return row.uuid === data.uuid })
      const rowData = this.rowData
      rowData[index] = data
      this.clickRow = data
      this.rowData = [...rowData]
      this.gridOptions.api.refreshCells({ force: true })
      this.$emit('queryResultCallBack', this.rowData)
      this.$emit('clickedCallBack', data)
    },
    /** *********列数据渲染函数 begin********** **/
    numberColumnLabelFunc(data, dataField) {
      if (!data) {
        return ''
      }
      if (data.ar && dataField === 'arAmount') {
        return ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'amount'), 2)
      }
      if (!data.ar && dataField === 'apAmount') {
        return ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'amount'), 2)
      }
      return '0.00'
    },
    // 剩余金额
    remainAmountLabelFunc(item) {
      // ActualAmount
      const act = item
      if (act) {
        return ColumnUtils.formatNumberReturnZero(act.amount - act.verfiedAmount, 2)
      }
      return '0.00'
    },

    amountNumberColumnLabelFunc(data, dataField) {
      if (!data) return ''
      let displayAmount = '0.00'
      if (data.hasOwnProperty('isPrepay') && data.isPrepay) {
        if (dataField === 'amount') {
          displayAmount = ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'amount'), 2)
        }
        if (dataField === 'verfiedAmount') {
          displayAmount = ColumnUtils.formatNumberReturnZero(ColumnUtils.getData(data, 'verfiedAmount'), 2)
        }
      } else {
        // 实收实付金额
        let amount = 0.00
        if (data.hasOwnProperty('amount') && data.amount) {
          amount = Number(data.amount)
        }
        // 财务费用
        let financialCost = 0.00
        if (data.hasOwnProperty('financialCost') && data.financialCost) {
          financialCost = Number(data.financialCost)
        }

        // 汇总损益
        let diffChange = 0.00
        if (data.hasOwnProperty('diffChange') && data.diffChange) {
          diffChange = Number(data.diffChange)
        }

        // 零头短账
        let clearOdd = 0.00
        if (data.hasOwnProperty('clearOdd') && data.clearOdd) {
          clearOdd = Number(data.clearOdd)
        }
        displayAmount = ColumnUtils.formatNumberReturnZero(amount + financialCost + diffChange + clearOdd, 2)
      }
      return displayAmount
    },
    // 水单状态
    cashTransferStateLabelFun(data, dataField) {
      // CashTransferState
      const common = this.getCashTransferStateByCode(data[dataField])
      return common == null ? this.$t('Clearing.NotUsed') : (this.isZh ? common.chineseName : common.englishName)
    },
    // 根据code获取水单状态对象
    getCashTransferStateByCode(code) {
      if (this.cashTransferStates.length === 0) {
        // 水单状态
        const CASH_TRANSFER_WSY = { code: 0, englishName: 'WSY', chineseName: '未使用' }
        const CASH_TRANSFER_GSD = { code: 1, englishName: 'GSD', chineseName: '挂水单' }
        const CASH_TRANSFER_SDK = { code: 2, englishName: 'SDK', chineseName: '收到款' }
        const CASH_TRANSFER_NDHD = { code: 3, englishName: 'NDHD', chineseName: '拿到回单' }
        this.cashTransferStates = [CASH_TRANSFER_WSY, CASH_TRANSFER_GSD, CASH_TRANSFER_SDK, CASH_TRANSFER_NDHD]
      }
      for (let i = 0; i < this.cashTransferStates.length; i++) {
        if (this.cashTransferStates[i].code === code) {
          return this.cashTransferStates[i]
        }
      }
      return null
    },
    queryOurBankLabelFunc(data) {
      let text = data.ourBank
      if (data.ourBank === '' || data.ourBank === null) {
        for (const bankAccount of this.bankAccounts) {
          if (bankAccount.accountNo === data.ourBankAccount && bankAccount.currency === data.currency) {
            text = bankAccount.bankChineseName
            break
          }
        }
      }
      return text
    },
    /** *********列数据渲染函数 end********** **/
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-actualamount')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (this.dialogHeight || (offset > containerHeight)) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    async initCustomSearchItems() {
      console.log('accountId', this.accountId)
      const defaultSearchFields = []
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'WriteOff.settlementCompany'
          searchField.itemName = 'actualAmount.ACCOUNTID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 我方银行
      if (this.bankAccounts) {
        const dataProvider = []
        for (const bankAccount of this.bankAccounts) {
          const chineseName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
          const englishName = '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankEnglishName
          // CARGO-15701，销账查询页签，我方银行的查询条件:币种+账号
          dataProvider.push({
            code: (bankAccount.accountNo + '' + bankAccount.currency),
            chineseName: chineseName,
            englishName: englishName
          })
        }
        console.log('ourSideBank ', dataProvider)
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        // 多选：支持 等于/不等于/包含/不包含（多选下 等于≡包含、不等于≡不包含）
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN, AdvancedSearchConsts.OPERATOR_NOT_IN]
        searchField.defaultConditionVal = OPERATOR_EQUAL.code
        searchField.defaultValue = []
        searchField.itemLabel = 'WriteOff.ourSideBank'
        searchField.itemName = 'actualAmount.OURBANK'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.lock = false
        searchField.dataProvider = dataProvider
        searchField.action = 2
        searchField.defaultSelected = 0
        searchField.selected = 0
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 销账抬头
      await this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.$store.getters.currentOfficeId }).then(res => {
        this.receiptInvoiceTitles = res.data
      })
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'actualAmount.ACTUAL_AMOUNT_TITLE'
      searchField.itemLabel = this.$t('CargoMsg.Cargo_WriteOffHeader')
      searchField.tagName = 'invoiceTitle'
      searchField.tagValue = 'invoiceTitle'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataProvider = this.receiptInvoiceTitles
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IS_NULL]
      searchField.filterType = 'global'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$PAYER_NAME'
      defaultSearchFields.push(searchField.formatObj2Json())

      // if (defaultSearchFields.length > 0) {
      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
      // }
      return this.customSearchItems
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 是否红冲
    isRedPunch() {
      return false
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
